import { Navigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth-context';
import { isPoaOnlyUser } from '@/lib/plan-access';
import PoaPage from '@/pages/PoaPage';

/** $197 POA buyers should use the step-form wizard, not static templates. */
export default function PoaTemplatesGate() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center">
        <div className="animate-pulse text-muted-foreground">Loading...</div>
      </div>
    );
  }

  if (isPoaOnlyUser(user)) {
    return <Navigate to="/poa-wizard" replace />;
  }

  return <PoaPage />;
}
